import { render } from "./CompareRackContainer.vue?vue&type=template&id=2844a2b9&scoped=true"
import script from "./CompareRackContainer.vue?vue&type=script&lang=js"
export * from "./CompareRackContainer.vue?vue&type=script&lang=js"

import "./CompareRackContainer.vue?vue&type=style&index=0&id=2844a2b9&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2844a2b9"]])

export default __exports__